import config from "../config/config";
import axios from "axios";
import { getToken } from "../Token";
import { getTimezoneInfo } from '../helpers/timezone_helper';
import { get, update } from "lodash";
import * as url from "../helpers/url_helper";

const { timezoneName, formattedOffset } = getTimezoneInfo();
const token = getToken();

export const ServiceCategoryRequestApi = {
    getAll: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.FETCH_SERVICE_REQUEST_CATEGORY}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data
        };
        return await axios(axiosConfig);
    },

    updateServiceCategoryRequestStatus: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.UPDATE_SERVICE_REQUEST_CATEGORY}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data
        };
        return await axios(axiosConfig);
    },

    getServiceCategoryRequestDetails: async (request_id) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.FETCH_SERVICE_REQUEST_CATEGORY_DETAILS}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data: { request_id }
        };
        return await axios(axiosConfig);
    },

    deleteServiceCategoryRequest: async (request_id) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.DELETE_SERVICE_REQUEST_CATEGORY}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data: { request_id }
        };
        return await axios(axiosConfig);
    },
    
};
